import { AutogenModelDrsPayrollHist, AutogenRowDrsPayrollHist } from "./autogen/AutogenModelDrsPayrollHist";

export class ModelDrsPayrollHist extends AutogenModelDrsPayrollHist<RowDrsPayrollHist> {
	constructor() {
		super(RowDrsPayrollHist);
	}
}

export class RowDrsPayrollHist extends AutogenRowDrsPayrollHist {
}